import { Routes } from '@angular/router';
import { InspectorSessionsComponent } from './pages/inspector/sessions/inspector-sessions.component';
import { InspectorCalendarComponent } from './pages/inspector/calendar/inspector-calendar.component';
import { StudentDashboardComponent } from './components/features/student/student-dashboard/student-dashboard.component';
import { StudentProfileComponent } from './components/features/student/student-profile/student-profile.component';
import { TeacherProfileComponent } from './components/features/teacher/teacher-profile/teacher-profile.component';
import { HomeComponent } from './components/layouts/home/home.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { TestYourselfComponent } from './components/features/student/test-yourself/test-yourself.component';
import { PracticeGeneratorComponent } from './components/features/student/practice-generator/practice-generator.component';
import { UserManagementComponent } from './components/features/admin/user-management/user-management.component';
import { SettingsComponent } from './components/features/admin/settings/settings.component';
import { DashboardComponent } from './components/features/admin/dashboard/dashboard.component';
import { ProfileComponent } from './components/features/admin/profile/profile.component';
import { TeacherDashboardComponent } from './components/features/teacher/teacher-dashboard/teacher-dashboard.component';
import { DailyOperationComponent } from './components/features/teacher/daily-operation/daily-operation.component';
import { FollowingComponent } from './components/features/teacher/following/following.component';
import { MyLibraryComponent } from './components/features/teacher/my-library/my-library.component';
import { CertificateComponent } from './components/features/teacher/certificate/certificate.component';
import { ConsultationComponent } from './components/features/teacher/consultation/consultation.component';
import { BankComponent } from './components/features/teacher/tests/bank/bank.component';
import { TestBuilderComponent } from './components/features/teacher/test-builder/test-builder.component';
import { OperationComponent } from './components/features/student/operation/operation.component';
import { MyCoursesComponent } from './components/features/student/my-courses/my-courses.component';
import { DigitalLibComponent } from './components/features/student/digital-lib/digital-lib.component';
import { HomeworkComponent } from './components/features/student/homework/homework.component';
import { ConsultComponent } from './components/features/student/consult/consult.component';
import { PlanComponent } from './components/features/student/plan/plan.component';
import { ResultComponent } from './components/features/student/result/result.component';
import { TestDetailComponent } from './components/features/teacher/test-detail/test-detail.component';
import { RoleGuard } from './core/guards/role.guard';
import { AuthRedirectComponent } from './components/features/auth/auth-redirect/auth-redirect.component';
import { UnauthorizedComponent } from './components/pages/unauthorized/unauthorized.component';
import { AccountUnlinkedComponent } from './components/pages/account-unlinked/account-unlinked.component';
import { ChooseSpaceComponent } from './components/pages/choose-space/choose-space.component';
import { AccountLinkGuard } from './core/guards/account-link.guard';
import { RegistrationPendingComponent } from './components/pages/registration-pending/registration-pending.component';
import { RegistrationStatusGuard } from './core/guards/registration-status.guard';
import { StudentFeatureGuard } from './core/guards/student-feature.guard';
import { ProfessorsComponent } from './components/features/admin/professors/professors.component';
import { StudentsComponent } from './components/features/admin/students/students.component';
import { RegistrationsComponent } from './components/features/admin/registrations/registrations.component';
import { PacksComponent } from './components/features/admin/packs/packs.component';
import { PaymentMethodsComponent } from './components/features/admin/payment-methods/payment-methods.component';
import { LearningPathComponent } from './components/features/admin/learning-path/learning-path.component';
import { ThemeComponent } from './components/features/admin/theme/theme.component';
import { TestsComponent } from './components/features/student/tests/tests.component';
import { TestsHubComponent } from './components/features/student/tests/tests-hub/tests-hub.component';
import { TestsComponent as TeacherTestsComponent } from './components/features/teacher/tests/tests.component';
import { DiagTestComponent } from './components/features/student/diag-test/diag-test.component';
import { AcademicFollowingComponent } from './components/features/teacher/consultation/academic-following/academic-following.component';
import { MedicalFileComponent } from './components/features/teacher/consultation/medical-file/medical-file.component';
import { BehaviorReportComponent } from './components/features/teacher/consultation/behavior-report/behavior-report.component';
import { ParentCommunicationComponent } from './components/features/teacher/consultation/parent-communication/parent-communication.component';
import { AttendanceReportComponent } from './components/features/teacher/consultation/attendance-report/attendance-report.component';
import { ThemesComponent } from './components/features/teacher/tests/themes/themes.component';
import { DailyActivitiesComponent } from './components/features/student/tests/daily-activities/daily-activities.component';
import { EvaluationTestComponent } from './components/features/student/tests/evaluation-test/evaluation-test.component';
import { ExamComponent } from './components/features/student/tests/exam/exam.component';
import { StudentTestSessionComponent } from './components/features/student/student-test-session/student-test-session.component';
import { TestSessionGuard } from './core/guards/test-session.guard';
import { AgendaComponent } from './components/features/student/agenda/agenda.component';
import { SubjectsListComponent } from './components/features/student/subjects-list/subjects-list.component';
import { SessionDetailComponent } from './components/features/teacher/session-detail/session-detail.component';
import { AdminStudentFollowingComponent } from './pages/admin/student-following/admin-student-following.component';
import { AcademicPeriodsComponent } from './pages/admin/academic-periods/academic-periods.component';
import { EvaluationBandsComponent } from './pages/admin/evaluation-bands/evaluation-bands.component';
import { AdminCalendarComponent } from './components/features/admin/calendar/calendar.component';
import { TeacherGroupsComponent } from './components/features/teacher/groups/groups.component';
import { TeacherAssignmentsComponent } from './components/features/teacher/assignments/assignments.component';
import { TeacherCalendarComponent } from './components/features/teacher/calendar/calendar.component';
import { AdminGroupsComponent } from './pages/admin/groups/admin-groups.component';
import { AdminLibraryComponent } from './pages/admin/library/admin-library.component';
import { AdminTestsComponent } from './pages/admin/tests/admin-tests.component';
import { AdminActivityComponent } from './pages/admin/activity/admin-activity.component';
import { AccessComponent } from './pages/admin/access/access.component';
import { QuestionBankComponent } from './components/features/questions/question-bank/question-bank.component';
import { ReviewQueueComponent } from './components/features/questions/review-queue/review-queue.component';
import { QuestionCreateComponent } from './components/features/questions/question-create/question-create.component';
import { QuestionEditComponent } from './components/features/questions/question-edit/question-edit.component';
import { TestImportComponent } from './components/features/teacher/test-import/test-import.component';
import { DiagnosticReportComponent } from './components/features/student/diagnostic-report/diagnostic-report.component';
import { AdminAssistanceComponent } from './pages/admin/assistance/admin-assistance.component';
import { AssistanceComponent } from './components/features/shared/assistance/assistance.component';
import { SessionJoinLandingComponent } from './components/pages/session-join-landing/session-join-landing.component';

export const routes: Routes = [
  // Auto-redirect route
  { path: '', component: AuthRedirectComponent },

  // ─── Inspection ───────────────────────────────────────────────────
  // Gardée par une **permission**, pas par un rôle : `RoleGuard` compare des
  // chaînes issues de `getUserRoles(true)`, qui rend realm et client
  // confondus — un nom de permission y passe tel quel. C'est ce qui laisse un
  // professeur-inspecteur, un superviseur et un inspecteur pur entrer par la
  // même porte, sans que la route connaisse aucun d'eux.
  {
    path: 'inspector',
    component: HomeComponent,
    canActivate: [RoleGuard],
    data: { breadcrumb: 'CRUMBS.HOME', roles: ['sessions.inspect'] },
    children: [
      { path: '', redirectTo: 'sessions', pathMatch: 'full' },
      {
        path: 'sessions',
        component: InspectorSessionsComponent,
        data: { breadcrumb: 'CRUMBS.INSPECTION' },
      },
      {
        // Les mêmes séances, en agenda : inspecter depuis la fiche.
        path: 'calendar',
        component: InspectorCalendarComponent,
        data: { breadcrumb: 'SIDEBAR.CALENDAR' },
      },

      // Les écrans de l'administration, réutilisés tels quels sous une garde
      // qui leur est propre.
      //
      // Le shell `/admin` n'est pas ouvert à l'inspecteur, et ce serait la
      // faute à ne pas commettre : ses enfants n'ont aucune garde individuelle
      // — ils s'en remettent au parent. Élargir ce parent donnerait accès aux
      // trente écrans qu'il abrite, dont la gestion des inscriptions et des
      // paiements. Chaque route ci-dessous déclare donc la sienne, et le back
      // la redemande de son côté.
      {
        path: 'library',
        component: AdminLibraryComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'LIBRARY.ADMIN.TITLE', roles: ['library.read.all'] },
      },
      {
        path: 'professors',
        component: ProfessorsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.PROFESSORS', roles: ['professors.read'] },
      },
      {
        // Son journal, et lui seul : `scope` bascule l'écran sur l'endpoint où
        // le serveur impose l'auteur.
        path: 'activity',
        component: AdminActivityComponent,
        canActivate: [RoleGuard],
        data: {
          breadcrumb: 'ACTIVITY.TITLE',
          roles: ['activity.read.own'],
          scope: 'own',
        },
      },
    ],
  },

  // Admin Routes
  {
    path: 'admin',
    component: HomeComponent,
    canActivate: [RoleGuard],
    // Le rôle de base ouvre l'espace ; chaque écran, en dessous, demande sa
    // permission — et le superviseur passe partout, par décision.
    data: { breadcrumb: 'CRUMBS.HOME', roles: ['supervisor', 'admin'] },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: { breadcrumb: 'CRUMBS.PROFILE' },
      },
      {
        path: 'professors',
        component: ProfessorsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.PROFESSORS', roles: ['professors.read'] },
      },
      {
        path: 'students',
        component: StudentsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.STUDENTS', roles: ['students.read.all'] },
      },
      {
        // File de validation des inscriptions venues du site vitrine.
        path: 'registrations',
        component: RegistrationsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.REGISTRATIONS', roles: ['registrations.read'] },
      },
      {
        // Offres commerciales et grille tarifaire par matière.
        path: 'packs',
        component: PacksComponent,
        canActivate: [RoleGuard],
        // Sa propre permission, comme côté serveur. L'une suffit : avec la
        // lecture seule l'écran s'ouvre en consultation.
        data: { breadcrumb: 'SIDEBAR.PACKS', roles: ['packs.read'] },
      },
      {
        // Profils d'accès : au superviseur seul — gérer les profils, c'est
        // pouvoir s'en attribuer un. Le back le redemande.
        path: 'access',
        component: AccessComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'ACCESS.TITLE', roles: ['supervisor'] },
      },
      {
        // Comment un élève paie ce que la grille ci-dessus a chiffré.
        path: 'payment-methods',
        component: PaymentMethodsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.PAYMENT_METHODS', roles: ['payments.read'] },
      },
      {
        path: 'users',
        component: UserManagementComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.USERS', roles: ['supervisor'] },
      },
      {
        path: 'learning-paths',
        component: LearningPathComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.LEARNING_PATHS', roles: ['referential.read'] },
      },
      // Les matières se gèrent dans leur parcours, sur le même écran. L'ancien
      // chemin circule dans les favoris et l'historique : il y mène.
      { path: 'subjects', redirectTo: 'learning-paths', pathMatch: 'full' },
      {
        path: 'themes',
        component: ThemeComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.THEMES', roles: ['referential.read'] },
      },
      {
        path: 'academic-periods',
        component: AcademicPeriodsComponent,
        canActivate: [RoleGuard],
        // Le serveur ouvre la lecture à `referential.read` : la route aussi.
        // L'écran passe en consultation seule sans `referential.write`.
        data: { breadcrumb: 'SIDEBAR.ACADEMIC_PERIODS', roles: ['referential.read'] },
      },
      {
        path: 'evaluation-bands',
        component: EvaluationBandsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'EVAL_BANDS.TITLE', roles: ['referential.read'] },
      },
      {
        path: 'calendar',
        component: AdminCalendarComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'ADMIN_CALENDAR.TITLE', roles: ['sessions.read.all'] },
      }
      ,
      {
        path: 'groups',
        component: AdminGroupsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'GROUPS.ADMIN_TITLE', roles: ['groups.read'] },
      },
      {
        path: 'library',
        component: AdminLibraryComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'LIBRARY.ADMIN.TITLE', roles: ['library.read.all'] },
      },
      {
        // Tous les tests de l'établissement : la seule vue transversale, par
        // professeur, parcours et matière. Le professeur, lui, ne voit que
        // les siens.
        path: 'tests',
        component: AdminTestsComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'ADMIN_TESTS.TITLE', roles: ['tests.read.all'] },
      },
      {
        path: 'test/:id',
        component: TestDetailComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.TEST_DET', roles: ['tests.read.all'] },
      },
      {
        // Le suivi des élèves existait pour le seul professeur, borné aux
        // matières qu'il enseigne. L'administration voit les mêmes copies sans
        // cette borne, et peut les filtrer par parcours, matière et auteur du
        // test. Même table, même composant : c'est ce qui garantit que les deux
        // écrans continueront de dire la même chose du même élève.
        path: 'student-following',
        component: AdminStudentFollowingComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'FOLLOWING.ADMIN_TITLE', roles: ['supervisor'] },
      },
      {
        path: 'student-following/session/:id',
        component: SessionDetailComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.SESSION_DETAIL', roles: ['supervisor'] },
      },
      {
        // L'édition réutilise le compositeur, comme côté enseignant : c'est le
        // même écran, l'admin y voit simplement tous les parcours.
        path: 'test/update/:id',
        component: TestBuilderComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.UPDATE_TEST', roles: ['tests.write.all'] },
      },
      {
        path: 'question-bank',
        component: QuestionBankComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.QUESTION_BANK', roles: ['questions.read.all'] },
      },
      {
        path: 'review-queue',
        component: ReviewQueueComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.REVIEW_QUEUE', roles: ['questions.write.all'] },
      },
      {
        path: 'questions/new',
        component: QuestionCreateComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.QUESTION_CREATE', roles: ['questions.write.all'] },
      },
      {
        path: 'questions/:id/edit',
        component: QuestionEditComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.QUESTION_EDIT', roles: ['questions.write.all'] },
      },
      {
        // Composition de test côté admin (mêmes écran/logique que l'enseignant,
        // mais l'admin voit tous les parcours).
        path: 'create-test',
        component: TestBuilderComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.CREATE_TEST', roles: ['tests.write.all'] },
      },
      {
        // Import d'un référentiel (Word/PDF) vers la banque de questions.
        path: 'tests/import',
        component: TestImportComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'CRUMBS.TEST_IMPORT', roles: ['tests.write.all'] },
      },
      {
        // Le rapport a quitté la coquille — voir la route racine plus bas.
        // L'ancienne adresse est conservée en redirection : elle circule dans
        // les fils d'Ariane et les liens déjà partagés.
        path: 'students/:studentId/diagnostic-report',
        redirectTo: '/diagnostic-report/students/:studentId',
        pathMatch: 'full',
      },
      {
        // Journal d'activité et fréquentation. Réservé à l'administration :
        // un journal consultable par ceux qu'il trace n'en est plus un.
        path: 'activity',
        component: AdminActivityComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'ACTIVITY.TITLE', roles: ['activity.read.all'] },
      },
      {
        path: 'assistance',
        component: AdminAssistanceComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.MANAGE_ASSISTANCE', roles: ['assistance.write'] },
      },
      {
        // La page d'aide en lecture — la même que celle des professeurs et des
        // élèves, sans aucune écriture. L'équipe y lit ses propres modules, et
        // ceux des autres publics tels qu'ils les voient (?as=Professor).
        path: 'help',
        component: AssistanceComponent,
        canActivate: [RoleGuard],
        data: { breadcrumb: 'SIDEBAR.ASSISTANCE', roles: ['assistance.read.all'] },
      },
      {
        path: 'settings',
        component: SettingsComponent,
        data: { breadcrumb: 'SIDEBAR.SETTINGS' },
      },

    ],
  },

  // Teacher Routes
  {
    path: 'teacher',
    component: HomeComponent,
    // AccountLinkGuard après RoleGuard : on ne vérifie le rattachement de la
    // fiche qu'une fois le rôle établi.
    canActivate: [RoleGuard, AccountLinkGuard],
    data: { breadcrumb: 'CRUMBS.HOME', roles: ['teacher', 'professor'] },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: TeacherDashboardComponent,
      },
      {
        path: 'tests',
        component: TeacherTestsComponent,
        data: { breadcrumb: 'CRUMBS.TESTS' },
        children: [
          {
            path: '',
            redirectTo: 'bank',
            pathMatch: 'full',
          },
          {
            path: 'bank',
            component: BankComponent,
            //data: { breadcrumb: 'SIDEBAR.THEMES' },
          },
          {
            path: 'themes',
            component: ThemesComponent,
            data: { breadcrumb: 'SIDEBAR.THEMES' },
          },
        ],
      },
      {
        // Nouveau parcours de composition (maquette test-builder) : la banque
        // devient un volet de la création plutôt qu'une destination isolée.
        path: 'create-test',
        component: TestBuilderComponent,
        data: { breadcrumb: 'CRUMBS.CREATE_TEST' },
      },
      {
        // Import d'un référentiel (Word/PDF) vers la banque de questions.
        path: 'tests/import',
        component: TestImportComponent,
        data: { breadcrumb: 'CRUMBS.TEST_IMPORT' },
      },
      {
        // L'ancien « teste-toi » enseignant est absorbé par le compositeur
        // (le mode se choisit dans l'écran) : on redirige vers le nouveau.
        path: 'create-test-yourself',
        redirectTo: 'create-test',
        pathMatch: 'full',
      },
      {
        path: 'operations',
        component: DailyOperationComponent,
        data: { breadcrumb: 'CRUMBS.DAILY_OP' },
      },
      {
        path: 'my-students',
        component: FollowingComponent,
        data: { breadcrumb: 'CRUMBS.FOLLOW_STD' },
      },
      {
        path: 'my-students/session/:id',
        component: SessionDetailComponent,
        data: { breadcrumb: 'CRUMBS.SESSION_DETAIL' },
      },
      {
        path: 'library',
        component: MyLibraryComponent,
        data: { breadcrumb: 'CRUMBS.LIBRARY' },
      },
      {
        path: 'groups',
        component: TeacherGroupsComponent,
        data: { breadcrumb: 'GROUPS.TITLE' },
      },
      {
        path: 'assignments',
        component: TeacherAssignmentsComponent,
        data: { breadcrumb: 'ASSIGNMENTS.TITLE' },
      },
      {
        path: 'calendar',
        component: TeacherCalendarComponent,
        data: { breadcrumb: 'CALENDAR.TITLE' },
      },
      {
        path: 'question-bank',
        component: QuestionBankComponent,
        data: { breadcrumb: 'CRUMBS.QUESTION_BANK' },
      },
      {
        path: 'questions/new',
        component: QuestionCreateComponent,
        data: { breadcrumb: 'CRUMBS.QUESTION_CREATE' },
      },
      {
        path: 'questions/:id/edit',
        component: QuestionEditComponent,
        data: { breadcrumb: 'CRUMBS.QUESTION_EDIT' },
      },
      {
        path: 'review-queue',
        component: ReviewQueueComponent,
        data: { breadcrumb: 'CRUMBS.REVIEW_QUEUE' },
      },
      {
        path: 'certificates',
        component: CertificateComponent,
        data: { breadcrumb: 'CRUMBS.CERTIF' },
      },
      {
        path: 'consultations',
        component: ConsultationComponent,
        data: { breadcrumb: 'CRUMBS.CONSULT' },
        children: [
          {
            path: '',
            redirectTo: 'academic-following',
            pathMatch: 'full',
          },
          {
            path: 'academic-following',
            component: AcademicFollowingComponent,
            data: { breadcrumb: 'CRUMBS.ACADEMIC_FOLLOWING' },
          },
          {
            path: 'medical-file',
            component: MedicalFileComponent,
            data: { breadcrumb: 'CRUMBS.MEDICAL_FILE' },
          },
          {
            path: 'behavior-report',
            component: BehaviorReportComponent,
            data: { breadcrumb: 'CRUMBS.BEHAVIOR_REPORT' },
          },
          {
            path: 'parent-communication',
            component: ParentCommunicationComponent,
            data: { breadcrumb: 'CRUMBS.PARENT_COMMUNICATION' },
          },
          {
            path: 'attendance-report',
            component: AttendanceReportComponent,
            data: { breadcrumb: 'CRUMBS.ATTENDANCE_REPORT' },
          },
        ],
      },
      {
        path: 'assistance',
        component: AssistanceComponent,
        data: { breadcrumb: 'SIDEBAR.ASSISTANCE' },
      },
      {
        path: 'profile/:id',
        component: TeacherProfileComponent,
        data: { breadcrumb: 'CRUMBS.PROFILE' },
      },
      {
        path: 'test/:id',
        component: TestDetailComponent,
        data: { breadcrumb: 'CRUMBS.TEST_DET' },
      },
      {
        // L'édition d'un test réutilise le compositeur (mode édition via `:id`)
        // au lieu de l'ancien écran de mise à jour.
        path: 'test/update/:id',
        component: TestBuilderComponent,
        data: { breadcrumb: 'CRUMBS.UPDATE_TEST' },
      },
    ],
  },

  // Student Routes
  {
    path: 'student',
    component: HomeComponent,
    canActivate: [RoleGuard, AccountLinkGuard, RegistrationStatusGuard],
    data: { breadcrumb: 'CRUMBS.HOME', roles: ['student'] },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: StudentDashboardComponent,
      },
      {
        path: 'profile',
        component: StudentProfileComponent,
        data: { breadcrumb: 'PROFILE.TITLE' },
      },
      {
        // Idem : le rapport se lit hors coquille, l'adresse reste valide.
        path: 'diagnostic-report',
        redirectTo: '/diagnostic-report',
        pathMatch: 'full',
      },

      {
        // L'espace tests s'ouvre au pack qui inclut l'un des trois types de
        // test ; le hub n'y montre ensuite que ceux que le pack ouvre
        // (SKILL2ERA-137).
        path: 'tests',
        component: TestsComponent,
        canActivate: [StudentFeatureGuard],
        data: { breadcrumb: 'CRUMBS.TESTS', feature: ['diagnostic', 'practice', 'exams'] },
        children: [
          {
            // Une seule page : matières à gauche, diagnostic, entraînement,
            // devoirs et copies à droite. Elle remplace la navigation à trois
            // niveaux (grille → espace matière → trois onglets), elle-même
            // dédoublée par deux entrées de menu.
            path: '',
            component: TestsHubComponent,
            data: { breadcrumb: 'TESTS_HUB.TITLE' },
          },
          // Anciens chemins conservés en redirection : ils circulent dans les
          // favoris, les notifications déjà envoyées et l'historique des
          // navigateurs. Les casser produirait des 404 sans bénéfice.
          { path: 'subjects', redirectTo: '', pathMatch: 'full' },
          { path: 'practice', redirectTo: '', pathMatch: 'full' },
          { path: 'diagnostic', redirectTo: '', pathMatch: 'full' },
          { path: 'subject/:subjectId/:menu', redirectTo: '', pathMatch: 'full' },
          {
            path: 'exam',
            component: ExamComponent,
            canActivate: [StudentFeatureGuard],
            data: { breadcrumb: 'CRUMBS.TEST_YOURSELF', feature: 'exams' },
          },
          {
            // `evaluation` est, en base, le mode du test diagnostique.
            path: 'evaluation',
            component: EvaluationTestComponent,
            canActivate: [StudentFeatureGuard],
            data: { breadcrumb: 'SIDEBAR.EVALUATION', feature: 'diagnostic' },
          },
          {
            // « Teste-toi » sert désormais le générateur d'entraînement pondéré
            // par la progression (maquette practice-generator, lot L10) — il
            // remplace l'ancien écran statique d'auto-évaluation.
            path: 'test-yourself',
            component: PracticeGeneratorComponent,
            canActivate: [StudentFeatureGuard],
            data: { breadcrumb: 'CRUMBS.TEST_YOURSELF', feature: 'practice' },
          },
          {
            // Nouveau moteur de génération pondéré par la progression (lot L10).
            path: 'generate',
            component: PracticeGeneratorComponent,
            canActivate: [StudentFeatureGuard],
            data: { breadcrumb: 'CRUMBS.PRACTICE', feature: 'practice' },
          },
        ],
      },
      {
        // Passation et résultats restent hors garde de route : ils servent
        // les trois types de test et les devoirs. Le serveur refuse de démarrer
        // un test dont le pack n'ouvre pas le mode, test par test.
        path: 'test/take/:id',
        component: StudentTestSessionComponent,
        canDeactivate: [TestSessionGuard],
      },
      { path: 'test/results/:id', component: ResultComponent },
      {
        path: 'diagnostic-test',
        component: DiagTestComponent,
        data: { breadcrumb: 'TESTS.DIAG' },
      },
      {
        path: 'results',
        component: ResultComponent,
        data: { breadcrumb: 'CRUMBS.RESULTS' },
      },
      {
        path: 'operations',
        component: OperationComponent,
        data: { breadcrumb: 'CRUMBS.DAILY_OP' },
      },
      {
        path: 'courses',
        component: MyCoursesComponent,
        data: { breadcrumb: 'CRUMBS.COURSES' },
      },
      {
        path: 'library',
        component: DigitalLibComponent,
        canActivate: [StudentFeatureGuard],
        data: { breadcrumb: 'CRUMBS.LIBRARY', feature: 'library' },
      },
      {
        path: 'daily-activities',
        component: DailyActivitiesComponent,
        data: { breadcrumb: 'SIDEBAR.DAILY_ACTIVITIES' },
      },
      {
        path: 'homework',
        component: HomeworkComponent,
        canActivate: [StudentFeatureGuard],
        data: { breadcrumb: 'CRUMBS.CERTIF', feature: 'homework' },
      },
      {
        path: 'assistance',
        component: AssistanceComponent,
        canActivate: [StudentFeatureGuard],
        data: { breadcrumb: 'SIDEBAR.ASSISTANCE', feature: 'assistance' },
      },
      {
        path: 'planning',
        component: PlanComponent,
        data: { breadcrumb: 'CRUMBS.CONSULT' },
      },
      {
        path: 'consultations',
        component: ConsultComponent,
        data: { breadcrumb: 'CRUMBS.CONSULT' },
      },
      {
        path: 'agenda',
        component: AgendaComponent,
        canActivate: [StudentFeatureGuard],
        data: { breadcrumb: 'SIDEBAR.APPOINTMENTS', feature: 'agenda' },
      },
      {
        path: 'subjects',
        component: SubjectsListComponent,
        data: { breadcrumb: 'SUBJECTS.LIST_TITLE' },
      },

    ],
  },
  // Rapport de diagnostic — hors des coquilles de rôle, volontairement.
  //
  // Le rapport porte son propre en-tête, suppose la largeur entière et son
  // export PDF est l'impression de la page : l'afficher dans la coquille
  // livrerait un document encadré par un menu, sur une colonne trop étroite
  // pour sa feuille A4.
  //
  // `?subject=<id>` restreint l'affichage à une matière — pas les données
  // reçues ; sans le paramètre, le rapport couvre toutes les matières et se
  // termine par les deux blocs d'ensemble.
  {
    // Mêmes gardes que la coquille élève, dans le même ordre : sortir de la
    // coquille ne doit pas ouvrir une porte dérobée à un compte non rattaché
    // ou dont l'inscription n'est pas encore validée.
    path: 'diagnostic-report',
    component: DiagnosticReportComponent,
    canActivate: [RoleGuard, AccountLinkGuard, RegistrationStatusGuard],
    data: { roles: ['student'] },
  },
  {
    // Même écran, côté encadrement.
    //
    // Réservé à qui détient `tests.read.all` — le superviseur, par décision —,
    // la règle exacte de `GET api/diagnostic-reports/students/{id}`. Les
    // boutons qui y mènent, depuis le rapport d'une session (`session-detail`)
    // et la liste des élèves suivis (`student-sessions-tab`), suivent la même
    // condition (`*appCan`).
    //
    // <p><b>Pas le professeur, délibérément.</b> Le serveur a été fermé parce
    // qu'il servait le bilan sur toutes les matières, y compris celles que le
    // professeur n'enseigne pas. La vue professeur, bornée à ses matières côté
    // serveur, reste à écrire après validation de l'écran élève ; d'ici là, il
    // ne voit ni la route ni les boutons.</p>
    path: 'diagnostic-report/students/:studentId',
    component: DiagnosticReportComponent,
    canActivate: [RoleGuard],
    data: { roles: ['tests.read.all'] },
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  // Compte authentifié mais sans fiche métier : distinct de « non autorisé »,
  // la cause et la marche à suivre n'étant pas les mêmes.
  { path: 'account-unlinked', component: AccountUnlinkedComponent },
  // « Continuer en tant que » : première connexion d'un compte qui ouvre
  // plusieurs espaces. Hors coquille : il n'y a pas encore de menu à montrer.
  { path: 'choose-space', component: ChooseSpaceComponent },
  // Inscription en ligne pas encore validée : hors du shell élève, dont
  // l'accès est justement ce que l'on bloque. C'est ici que se dépose
  // l'ordre de virement.
  {
    path: 'registration-pending',
    component: RegistrationPendingComponent,
    canActivate: [RoleGuard],
    data: { roles: ['student'] },
  },
  // Atterrissage du bouton « Rejoindre la séance » du mail de rappel. Hors
  // coquille : la présence est journalisée puis l'onglet part vers la visio,
  // quel que soit le rôle — élève, professeur, inspecteur (et le superviseur,
  // que la permission à point laisse passer). `RoleGuard` et non `AuthGuard` :
  // lui seul garde l'adresse demandée à travers la connexion Keycloak, et
  // l'élève qui clique depuis son mail arrive déconnecté.
  {
    path: 'sessions/:id/join',
    component: SessionJoinLandingComponent,
    canActivate: [RoleGuard],
    data: { roles: ['student', 'professor', 'teacher', 'sessions.inspect'] },
  },
  { path: '**', component: NotFoundComponent },
];
